import axios from "axios";
export const signupAdmin = async (data) => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_AUTH+`/auth/signup-admin`, data);
      return response;
    } catch (error) {
      throw error;
    }
};
export const getAllAdmin = async (data) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_AUTH+`/admins`, data);
      return response;
    } catch (error) {
      throw error;
    }
};